import { useBooleanFlagValue } from '@openfeature/react-sdk';

export type AssetVariant = 'thumb' | 'preview';

export function useAssetVariant(desired: AssetVariant): AssetVariant | undefined {
  const enabled = useBooleanFlagValue('content_studio_mvp', false);
  return enabled ? desired : undefined;
}
